import React, { useState } from 'react';

export default function AccordionItem({ id, title, icon, defaultOpen = false, children }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button 
          className={`accordion-button image-tab ${!isOpen ? 'collapsed' : ''}`} 
          type="button" 
          onClick={() => setIsOpen(!isOpen)}
        >
          <span style={{ marginLeft: '0.5rem', marginRight: '1rem' }}>{icon}</span> <span style={{ marginTop: '0.25rem' }}>{title}</span>
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
        <div className="accordion-body " style={{ padding: "2rem" }}>
          {children}
        </div>
      </div>
    </div>
  );
}